"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function SignOutIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "20px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style, className = _a.className;
    return (react_1.default.createElement("svg", { height: height, className: className, style: style, viewBox: "0 0 100 100" },
        react_1.default.createElement("path", { fill: color, d: "M46.8,93a13,13,0,0,0,13-13V68.95a5,5,0,0,0-10,0V80a3,3,0,0,1-3,3h-27a3,3,0,0,1-3-3V20a3,3,0,0,1,3-3h27a3,3,0,0,1,3,3V31.2a5,5,0,1,0,10,0V20a13,13,0,0,0-13-13h-27a13,13,0,0,0-13,13V80a13,13,0,0,0,13,13Z" }),
        react_1.default.createElement("path", { fill: color, d: "M91.52,46.29l-21-21a5,5,0,0,0-7.07,7.07L76.09,45H33.8a5,5,0,0,0,0,10H76.09L63.41,67.68a5,5,0,1,0,7.07,7.07l21-21a4.94,4.94,0,0,0,0-7.42Z" })));
}
exports.default = SignOutIcon;
//# sourceMappingURL=index.js.map